export const messages = (state) => state.messages;
export const isLoadingMessages = (state) => state.isLoadingMessages;

export const genericDocuments = (state) => state.genericDocuments;
export const isLoadingGenericDocuments = (state) => state.isLoadingGenericDocuments;

export const unreadDocuments = (state) => state.unreadDocuments;
export const unreadDocumentsLast6Months = (state) => state.unreadDocumentsLast6Months;
export const hasUnreadDocumentsLast6Months = (state) => state.hasUnreadDocumentsLast6Months;
